import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AnalisisFuncionalInterface } from '@app/core/interfaces/analisis-funcional-interface';
import { ContactoInterface, RequestPostAsignarContacto, RequestPostContacto } from '@app/core/interfaces/contacto-interface';
import { IConceptos, IRequestPostConceptos } from '@app/core/interfaces/IConceptos';
import { ILineaInfraestructura, IRequestPostLineaInfraestructura } from '@app/core/interfaces/linea-infraestructura';
import { ProyectoItemsInterface, ProyectoItemModalidadesInterface, IProyectoItemEstado } from '@app/core/interfaces/proyecto-items-interface';
import { EstimacionesDepartamento, EstimacionInterface, RequestPatchEstimacionActual, RequestPostAnalisisFuncional, RequestPostRequisitos, RequisitosInterface } from '@app/admin/pages/oportunidades/helpers/interfaces/propuesta-interface';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RESPUESTA_ANALISISFUNCIONAL, RESPUESTA_ANALISISFUNCIONAL_ERROR, RESPUESTA_CONCEPTOS, RESPUESTA_ESTIMACION_PROYECTO, RESPUESTA_ESTIMACION_PROYECTO__ERROR_NOEDITABLE, RESPUESTA_REQUISITOS } from 'src/assets/dataDemo/proyectosDatos-demo';
import { ProcedenciasService } from '../procedencias/procedencias.service';
import { PropuestasService } from '../propuestas/propuestas.service';
import { TiposMedioContactoService } from '../tipos/tiposMedioContacto/tipos-medio-contacto.service';
import { TiposMetodoPagoService } from '../tipos/tiposMetodoPago/tipos-metodo-pago.service';
import { ProyectosService } from './proyectos.service';
import { IRespApi } from '@app/neo/neoShared/helpers/interfaces/IResp-api';
import { LOADER_TRANSPARENT } from '@app/neo/neoCore/interceptors/loaderInterceptor/loader.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ProyectoItemsService {

  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };


  public editandoRequisitos$ = new BehaviorSubject<boolean>(false);
  public editandoAnalisisFuncional$ = new BehaviorSubject<boolean>(false);
  
  public editando$ = new BehaviorSubject<boolean>(false);
  public editandoServicio$ = new BehaviorSubject<boolean>(false);

  urlProyectoItems   = environment.api_base_url + '/proyectoItems';
  urlProyectoItemEstados   = environment.api_base_url + '/proyectoItemEstados';
  urlProyectoItemModalidades   = environment.api_base_url + '/proyectoItemModalidades';
  urlProyectoItemEventos = environment.api_base_url + '/proyectoItemEventos';

  public proyectosItems$: BehaviorSubject<ProyectoItemsInterface[]> = new BehaviorSubject<ProyectoItemsInterface[]>(null);

  public proyectoItems$: BehaviorSubject<ProyectoItemsInterface> = new BehaviorSubject<ProyectoItemsInterface>(null);
  public totalProyectoItems$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  public proyectoItemModalidad$: BehaviorSubject<ProyectoItemModalidadesInterface> = new BehaviorSubject<ProyectoItemModalidadesInterface>(null);
  public error422Api$: Subject<RespApi> = new Subject<RespApi>();

  public contactoResponsableProyectoItem$: BehaviorSubject<ContactoInterface> = new BehaviorSubject<ContactoInterface>(null);
  public editandoContactoResponsableProyecto$ = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private procedenciasService: ProcedenciasService,
    private tiposMedioContactoService: TiposMedioContactoService,
    private tiposMetodoPagoService: TiposMetodoPagoService,
    // borar
    // private propuestaService: PropuestasService
  ) { }

  set editandoRequisitos(flag: boolean) {
    this.editandoRequisitos$.next(flag);
  }

  set contactoResponsableProyectoItem(contactoResponsableProyectoItem: ContactoInterface) {
    this.contactoResponsableProyectoItem$.next(contactoResponsableProyectoItem);
  }

  set editando(flag: boolean) {
    this.editando$.next(flag);
  }

  set editandoServicio(flag: boolean) {
    this.editandoServicio$.next(flag);
  }

  set editandoAnalisisFuncional(flag: boolean) {
    this.editandoAnalisisFuncional$.next(flag);
  }
  
  set editandoContactoResponsableProyecto(flag: boolean) {
    this.editandoContactoResponsableProyecto$.next(flag);
  }


  // llamar cuando este toda la informacion cargada para expandirlo
  set proyectoItems(proyectoItems: ProyectoItemsInterface) {    
    this.proyectoItems$.next(proyectoItems);
  }

  // set proyectoItems(proyectoItems: ProyectoItemsInterface) {

  //   if ( proyectoItems ) {
  //     this.entidadesRelacionadas( proyectoItems ).subscribe( response => {
  //       console.log('ENTIDADESRELACIONADAS PROYECTO ITEM', response);
  //       // let tipoMetodoPago         = response[0];
  //       let analisisFuncional      = response[0];
  //       let estimacion             = response[1];
  //       let lineasInfraestructura  = response[2];
  //       let requisitos             = response[3];
  //       let conceptos              = response[4];
  //       // let lineasInfraestructura= response[5];
  //       let fechaFormatt = new Date(proyectoItems?.fecha);
  //       let proyectoItemsMapeada = { ...proyectoItems, analisisFuncional, lineasInfraestructura, estimacion, requisitos,fechaFormatt, conceptos};
  //       this.proyectoItems$.next(proyectoItemsMapeada);
  //     })
  //   }
  // }
  
  entidadesRelacionadas(proyectoItem: ProyectoItemsInterface) {
    let peticion = {
      // responseTipoMetodoPago: this.tiposMetodoPagoService.get(proyectoItem?.idTipoMetodoPago).pipe(
      //   catchError(err => of(null))
      // ),
      analisisFuncional: this.getAnalisisFuncional(proyectoItem?.id).pipe(
        catchError(err => of(null))
      ),
      estimacion: this.getEstimacionActual( proyectoItem?.id ).pipe(
        catchError(err => of(null))
      ),
      // lineasInfraestructura: this.getLineasInfraestructura(proyectoItem?.id).pipe(
      //   catchError(err => of(null))
      // ),
      requisitos: this.getRequisitos( proyectoItem?.id ).pipe(
        tap(datos => console.log('requisitossss', datos)),
        map((data: any) => data = { ...data, requisitos: data?.contenido }),
        catchError(err => of(null))
      ),
      conceptos: this.getConceptos( proyectoItem?.id ).pipe(
        catchError(err => of(null))
      ),
    };
    return forkJoin(peticion);
  }

  set proyectoItemModalidad(proyectoItemModalidad: ProyectoItemModalidadesInterface) {
    this.proyectoItemModalidad$.next(proyectoItemModalidad);
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ProyectoItemsInterface[]> {
    return this.http.get(`${this.urlProyectoItems}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
      tap( (data: RespApi )=> {this.totalProyectoItems$.next( data.total );}),
      tap( (data: RespApi )=> {this.proyectosItems$.next( data.data );}),
      map((data: RespApi) => this.mapearProyectos(data['data']) ));
  }


  mapearProyectos(proyectos: ProyectoItemsInterface[]) {
    // if (proyectos.length && this.proyectosService.proyectos$.value) {
    //   proyectos.forEach((element, index )=> {
    //     console.log('Mapenado subproyecto ');
    //     element.proyecto = this.proyectosService.proyectos$.value.find(item=>item.id === element.idProyecto)  
    //   });
    // }
    return proyectos;
  }

  mapearListadosEntidadesRelacionadas(): Observable<any> {
    const responseProcedenciasService       = this.procedenciasService.getAll();
    const responseTiposMedioContactoService = this.tiposMedioContactoService.getAll();
    const responseTiposModalidadProyectoItem = this.getProyectoItemModalidades();
    const responseEstados = this.getEstados();
    return forkJoin([
      responseProcedenciasService,
      responseTiposMedioContactoService,
      responseTiposModalidadProyectoItem,
      responseEstados
    ])
  }


  get(id): Observable<ProyectoItemsInterface>{
    return this.http.get(`${this.urlProyectoItems}/${id}`).pipe(
      map((data: RespApi) => {
        let proyectoItem = data['data'];
        proyectoItem.esGitlab = this.auxiliar.getBoolean(proyectoItem?.esGitlab);
        return proyectoItem;
      })
    );
  }

  getEstados(): Observable<IProyectoItemEstado[]>  {
    return this.http.get(`${this.urlProyectoItemEstados}`).pipe(
      map((data: RespApi) => data['data'])
    );
  }

  establecerEstado(id: string, request: any) {
    if (!request['motivo']) {
      request['motivo'] = '';
    }
    return this.http.post(`${this.urlProyectoItems}/${id}/establecerEstado`, request).pipe(
      map((data: any[]) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostProyectoItems');
      })
    );
  }

  getProyectoItemModalidades(): Observable<ProyectoItemModalidadesInterface[]> {
    return this.http.get(this.urlProyectoItemModalidades, {}).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: ProyectoItemModalidadesInterface[]) => data['data']));
  }

  getItemProyectoItemModalidades(id): Observable<ProyectoItemModalidadesInterface>{
    return this.http.get(`${this.urlProyectoItemModalidades}/${id}`).pipe(
      map((data: RespApi) =>data['data'] ) );
  }

  create() {}

  
  update(id: string, request: any) {
  
    return this.http.patch( `${this.urlProyectoItems}/${id}`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPatchProyectoItems');
      })
    );
  }


  createComentarios() {}

  updateComentarios() {}
  /*********************/
  /* CONTACTOS       */
  /*********************/
  establecerEstadoEventos(id: string, request: any) {

    return this.http.post(`${this.urlProyectoItems}/${id}/establecerEvento`, request).pipe(
      map((data: any[]) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostProyectoItems');
      })
    );
  }

  getProyectoItemsEventosEstablecidos(id: string, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, loaderTransparente?: boolean): Observable<object[] | any> {
    let paramContext = (loaderTransparente) ? { ...this.contextLoaderTransparent } : {};

    let request = (paginatorType === TipoPaginadorEnum.offline)
      ? `${this.urlProyectoItems}/${id}/eventos`
      : `${this.urlProyectoItems}/${id}/eventos?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, paramContext).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, `IRequestGetProyectoItemsEventosEstablecidos`);
      })
    );
  }

  getProyectoItemsEventosAplicados(id: string,) {
    return this.http.get(`${this.urlProyectoItems}/${id}/eventos`, {}).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: ProyectoItemModalidadesInterface[]) => data['data']));
  }
  /*********************/
  /* CONTACTOS       */
  /*********************/
  crearContacto(id: string, request: RequestPostContacto) {
    let _request = {...request}
    console.log('[CREAR contacto ] ', id, _request);
    return this.http.post( `${this.urlProyectoItems}/${id}/contactoResponsableProyectoItem`, _request ).pipe(
      map((data: RespApi[]) => data['data']),
      catchError( (err: RespApi) => {
        return this.handleError( err,  'RequestPostContactoProyectoItem');
      })
    );
  }

  /*********************/
  /* REQUISITOS       */
  /*********************/
  getRequisitos(id: string) {
    // return new Observable<RequisitosInterface>( observer => {
    //   RESPUESTA_REQUISITOS['data']['requisitos'] = RESPUESTA_REQUISITOS['data']['contenido'];
    //   observer.next(RESPUESTA_REQUISITOS['data']);
    //   observer.complete();
    // });  
    return this.http.get(`${this.urlProyectoItems}/${id}/requisitos`).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err);
      }));
  }


  updateRequisitos(request: RequestPostRequisitos, idObjeto: string): Observable<any> {
    // // DEMO
    // RESPUESTA_REQUISITOS['data'].contenido = request.requisitos;
    // return new Observable<any>( observer => {
    //   observer.next(true);
    //   observer.complete();
    // });  
    return this.http.post(`${this.urlProyectoItems}/${idObjeto}/requisitos`, request).pipe(
      map((data: RespApi) => data),
      catchError((err: RespApi) => {
        return this.handleError(err);
      })
    );     
  }

 

  /****************************/
  /* ANALISIS FUNCIONAL       */
  /*****************************/
  getAnalisisFuncional(id: string): Observable<AnalisisFuncionalInterface> {
    // return new Observable<any>( observer => {
    //   observer.next(RESPUESTA_ANALISISFUNCIONAL['data']);
    //   observer.complete();
    // });     
    return this.http.get(`${this.urlProyectoItems}/${id}/analisisFuncional`).pipe(
      map((data: RespApi) => data['data'])
    );
  }  

    crearAnalisisFuncional(id: string, request: RequestPostAnalisisFuncional) {
      // DEMO OK
      RESPUESTA_ANALISISFUNCIONAL['data'].queHaremosDescripcionGeneral.contenido = request.queHaremosDescripcionGeneral;
      RESPUESTA_ANALISISFUNCIONAL['data'].queHaremosDescripcionTecnica.contenido = request.queHaremosDescripcionTecnica;
      RESPUESTA_ANALISISFUNCIONAL['data'].queNecesitamos.contenido = request.queNecesitamos;

      return new Observable<any>( observer => {
        observer.next(true);
        observer.complete();
      });  
      // DEMO KO
      // return this.http.post( `${this.urlProyectoItems}/${id}/analisisFuncional`, request ).pipe(
      //   map((data) => !data['error']),
      //   catchError( (err: RespApi) => {       
      //     return this.handleError( RESPUESTA_ANALISISFUNCIONAL_ERROR,  'RequestPostAnalisisFuncional');
      //   })
      // );
      // REAL 
      // return this.http.post( `${this.urlProyectoItems}/${id}/analisisFuncional`, request ).pipe(
      //   map((data) => !data['error']),
      //   catchError( (err: RespApi) => {       
      //     return this.handleError( err,  'RequestPostAnalisisFuncional');
      //   })
      // );
    }

  /****************************/
  /* ESTIMACION                */
  /*****************************/
  
  getEstimacionActual(id: string): Observable<EstimacionInterface> {
    return this.http.get(`${this.urlProyectoItems}/${id}/estimacionActual`).pipe(
      map((data: RespApi) => data['data']),
      map((data: EstimacionInterface) => {
        let estimacion = data;
        estimacion.activa = this.auxiliar.getBoolean(data?.activa);
        return data;
      })
    );
  }

  upadteEstimacionActual(id: string, request: any) {
   
    // DEMO OK
    
    RESPUESTA_ESTIMACION_PROYECTO['data'].estimacionesDepartamento = request;
    return new Observable<any>( observer => {
      observer.next(true);
      observer.complete();
    });  
    // DEMO KO
    // return this.http.patch( `${this.urlProyectoItems}/${id}/estimacionActual`, request ).pipe(
    //   map((data) => !data['error']),
    //   catchError( (err: RespApi) => {     
    //     return this.handleError( RESPUESTA_ESTIMACION_PROYECTO__ERROR_NOEDITABLE, 'RequestPatchEstimacionActual' );
    //   })
    // );

    // REAL
    // return this.http.patch( `${this.urlProyectoItems}/${id}/estimacionActual`, request ).pipe(
    //   map((data) => !data['error']),
    //   catchError( (err: RespApi) => {     
    //     return this.handleError( RESPUESTA_ESTIMACION_PROYECTO__ERROR_NOEDITABLE, 'RequestPatchEstimacionActual' );
    //   })
    // );
  }

  // getEstimacionActualDepartamento(id: string):  Observable<{[key: string]: EstimacionesDepartamento}> {
  //   return this.getEstimacionActual( id ).pipe(
  //     map(data => data['estimacionesDepartamento'])
  //   );
  // }

  // tieneEstimacion(id: string):Observable<any> {
  //   return this.getEstimacionActual( id ).pipe(
  //     map( estimacion => this.comprobarTieneEstimacion(estimacion) )
  //   )
  // }

  // comprobarTieneEstimacion(estimacion: EstimacionInterface): boolean {
  //   return Number(estimacion?.tiempoTotalMinimo) >0;
  // }

  /********************************/
  /* HITOS FACTURACION       */
  /********************************/
  getHitosFacturacion(id): Observable<any> {
    return this.http.get(`${this.urlProyectoItems}/${id}/hitosFacturacion`)
      .pipe(
        map((data: RespApi) => data['data']),
        catchError((err: RespApi) => {
          return this.handleError(err, 'RequestPostHitosFacturacionProyecto');
        })
      )
  }

  createHitosFacturacion(id: string, request: any): Observable<any> {
    request.hitosFacturacion.map(hito => {
      hito.idFacturacionConfiguracion = hito.idFactHitoConfiguracion
      // if (hito.fecha) {
      //   hito.valor = this.datepipe.transform(hito.fecha, 'dd/MM/yyyy');
      // }
    });
    return this.http.post<RespApi>(`${this.urlProyectoItems}/${id}/hitosFacturacion`, request).pipe(
      map((resp: RespApi) => resp.data),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostHitosFacturacionProyecto');
      })
    );
  }


  /********************************/
  /* CONCEPTOS       */
  /********************************/
  getConceptos(id): Observable<IConceptos> {

    return this.http.get(`${this.urlProyectoItems}/${id}/conceptos`)
      .pipe(
        map((data: RespApi) => data['data']),
        catchError((err: RespApi) => {
          return this.handleError(err, 'IRequestGetConceptosProyectoItem');
        })
      )
  }

  createConceptos(id: string, request: IRequestPostConceptos): Observable<any>{
    // DEMO
    console.log('CREATECONCEPTOS ');
    console.log(RESPUESTA_CONCEPTOS['data']);
    console.log('RECIBIMOS', request);
    RESPUESTA_CONCEPTOS['data'].conceptos = request.conceptos;
    return new Observable<any>( observer => {
      observer.next(true);
      observer.complete();
    });  
    // return this.http.post<RespApi>( `${this.urlProyectoItems}/${id}/conceptos`, request ) .pipe(
    //   map( (resp: RespApi) => resp.data),
    //   catchError( (err: RespApi) => {       
    //     return this.handleError( err,  'IRequestPostConceptos');
    //   })
    // );
  }

  /************************************ 
  * Eventos                *
  *************************************/
  getProyectoItemsEventos(){
    return this.http.get(`${this.urlProyectoItemEventos}`, {}).pipe(
      map((data: RespApi) => data['data'] ),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestProyectoItemEventos');
      })
    );
  }

  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {
      peticionProyectoItemEventos: this.getProyectoItemsEventos().pipe(
        catchError(err => of(null))
      ),
      estadosProyectoItems: this.getEstados().pipe(
        catchError(err => of(null))
      ),
    };
    const id = route.params.idServicio;
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    return forkJoin(peticion);
  }

    /********************************/
  /* MANEJADOR ERRORES            */
  /********************************/
  private handleError(err: RespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    if (err == 'Unknown Error') {
      let mensaje = environment.errorServidorUnknown;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    err.request = idRequest;
    if ( err.codigoError === 422) {
      this.error422Api$.next(err);
    } 

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404  || err.codigoError === 422) {
      let avisos = '';
      if ( err.data ) {
        err.data.forEach(element => {
          if ( element.id === 999 ) {
            avisos = ' ' + element.mensaje + ' ';
          }
        });
      }
      mensaje = (avisos.length)  ? avisos : err?.mensaje;
    }

    if (err.codigoError === 500) {
      let avisos = '';
      if ( err.data ) {
        err.data.forEach(element => {
          if ( element.id === 999 ) {
            avisos = ' ' + element.mensaje + ' ';
          }
        });
      }
      mensaje = err?.mensaje +  avisos;
    }
    console.log(` Error Operacion ${err.data} ${mensaje} ${err}`);
    return throwError({'error' : true, 'data': err.data, mensaje, 'err': err });
  }

  
    
}
